export const EMPTY_READONLY_ARRAY = new Proxy(Object.freeze([]), {
    set() {
        throw new Error('Cannot modify default array');
    },
});
export const EMPTY_ARRAY = EMPTY_READONLY_ARRAY;
export const EMPTY_OBJECT = new Proxy(Object.freeze({}), {
    set() {
        throw new Error('Cannot modify default object');
    },
});
//# sourceMappingURL=defaults.js.map